import React from "react";
import NewCaseField from "../shared/NewCaseField";

function UpdatePassword({ classes }) {
  return (
    <div className={classes.passwordContainer}>
      <div className={classes.parent}>
        <NewCaseField
          label={"Old password"}
          required={true}
          type={"password"}
          name={"old_password"}
        />
      </div>
      <div className={classes.parent}>
        <NewCaseField
          label={"Password"}
          required={true}
          type={"password"}
          name={"new_password"}
        />
      </div>
      <div className={classes.parent}>
        <NewCaseField
          label={"Confirm password"}
          required={true}
          type={"password"}
          name={"new_password_confirmation"}
        />
      </div>
    </div>
  );
}

export default UpdatePassword;
